import { errorConstants } from "../_constants";

// initial status of error object
const initState = {
   message: null,
   isOpen: false
};

export function error(state = initState, action){
  switch (action.type) {
    case errorConstants.SET_ERROR:
       return {
           message: action.message,
           isOpen: true
       };
    case errorConstants.HIDE_ERROR:
       return {
           message: null,
           isOpen: false
       };
    default:
      return state;
  }
}